import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { FAQS } from "../data/content";

export const Faq = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div className="rounded-2xl border border-ink/10 bg-white px-6 sm:px-8">
      {FAQS.map((f, i) => (
        <div key={f.q} className={i > 0 ? "border-t border-ink/10" : ""}>
          <button
            data-testid={`faq-question-${i}`}
            onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
            className="flex w-full items-center justify-between gap-4 py-5 text-left"
          >
            <span
              className={`font-heading text-base font-semibold transition-colors duration-200 ${
                openIdx === i ? "text-emerald-700" : "text-ink"
              }`}
            >
              {f.q}
            </span>
            <ChevronDown
              className={`h-5 w-5 shrink-0 text-ink/40 transition-transform duration-300 ${
                openIdx === i ? "rotate-180" : ""
              }`}
            />
          </button>
          <AnimatePresence initial={false}>
            {openIdx === i && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                className="overflow-hidden"
              >
                <p
                  className="pb-6 text-sm leading-relaxed text-ink/65"
                  data-testid={`faq-answer-${i}`}
                >
                  {f.a}
                </p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
};
